const DARKPOOL_PKG = {
    navTitle:"DarkPool",
    routerName: "DarkPoolDocs",
    commandsDescription: "All Things Dark Pool",

    commandList: [
        {
            title: "Summary DP",
            routerRef: "summarydp",
            commandString: "!summarydp <Interval> <Args>",
            description: "Summary of all prints by % of MarketCap - can also sort on other columns",
            parameters: [
                { name: "Interval: ", desc: "How many Days to go back - 0 is today - 1 includes yesterday etc" },
                { name: "Args: ", desc: "What you want to sort on (sum,float,short) does % of MC by default" },
            ],
            examples: [
                "!summarydp 0 float",
                "!summarydp 4",
                "!summarydp 6 sum",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "Summary DP",
            routerRef: "sectordp",
            commandString: "!sectordp <Interval> <Sector>",
            description: "Summary of all prints by % of MarketCap per sector",
            parameters: [
                { name: "Interval: ", desc: "How many Days to go back - 0 is today - 1 includes yesterday etc" },
                { name: "Sector: ", desc: "Sector to sort by - do !sectormap to get a list of all" },
            ],
            examples: [
                "!sectordp 0 CS",
                "!sectordp 4 E",
                "!sectordp 6 BM",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "Levels",
            routerRef: "levels",
            commandString: "!levels <Stock> <Interval>",
            description: "Biggest Levels for All Prints over X days",
            parameters: [
                { name: "Stock: ", desc: "Stock ticker to search" },
                { name: "Interval: ", desc: "How many Days to go back - 0 is today - 1 includes yesterday etc" },
            ],
            examples: [
                "!levels goog",
                "!levels goog 5",
                "!levels spy 10",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "Big Prints",
            routerRef: "bigprints",
            commandString: "!bigprints <Interval>",
            description: "Combination of Dark Pool and Blocks - Largest over x amount of time",
            parameters: [
                { name: "Interval: ", desc: "How many Days to go back - 0 is today - 1 includes yesterday etc" },
            ],
            examples: [
                "!bigprints 3",
                "!bigprints 0",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "All Prints",
            routerRef: "allprints",
            commandString: "!allprints <Stock>",
            description: "Last 10 Combination of Dark Pool and Blocks",
            parameters: [
                { name: "Stock: ", desc: "Stock ticker to search" },
            ],
            examples: [
                "!allprints goog",
                "!allprints amc",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "All Blocks",
            routerRef: "allblocks",
            commandString: "!allblocks <Stock>",
            description: "Last 10 Block trades for the given ticker",
            parameters: [
                { name: "Stock: ", desc: "Stock ticker to search" },
            ],
            examples: [
                "!allblocks goog",
                "!allblocks amc",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "All DarkPool",
            routerRef: "alldp",
            commandString: "!alldp <Stock>",
            description: "Last 10 Dark Pool trades for the given ticker",
            parameters: [
                { name: "Stock: ", desc: "Stock ticker to search" },
            ],
            examples: [
                "!alldp goog",
                "!alldp amc",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "Linked DP+Flow",
            routerRef: "linked",
            commandString: "!linked <Stock>",
            description: "Summary of prints from Previous day that have high probability of linked DP/Flow - run !linkedlist to get a list of stocks to run",
            parameters: [
                { name: "Stock: ", desc: "Stock to see linked prints from" },
            ],
            examples: [
                "!linked spy",
                "!linked amzn",
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "Top Dark Pool summary",
            routerRef: "topsum",
            commandString: "!topsum",
            description: "Summary of Dark Pool and Block Prints",
            parameters: ["none"],
            examples: [
                "!topsum"
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
        {
            title: "Linked List",
            routerRef: "linkedlist",
            commandString: "!linkedlist",
            description: "Returns eligible tickers to run for linked command",
            parameters: ["none"],
            examples: [
                "!linkedlist"
            ],
            type: "DarkPool",
            shortcuts: ["none"]
        },
    ]
}



export {DARKPOOL_PKG};